/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { SectionHeader } from '../Shared/SectionHeader'
import { Section } from '../Shared/Section'
import { CatalogHealthCard } from './Cards/CatalogHealthCard'
import { TopProductsCard } from './Cards/TopProductsCard/TopProductsCard'
import { PublishedProductsCard } from './Cards/PublishedProductsCard/PublishedProductsCard'
import { MarkupsCard } from './Cards/MarkupsCard/MarkupsCard'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import useUser from '../../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../../services/Provider/Provider.service'

const OfferPerformanceSection = () => {
    const {isMobile} = useDeviceMediaQuery()
    const {user} = useUser()

    return (
      <>
          <SectionHeader title={`Performance de l'offre`}/>

          <Section>
              <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    width: ${isMobile ? '340px' : '360px'};
                `}
              >
                  {isProviderAPos(user.provider) && <PublishedProductsCard/>}
                  <CatalogHealthCard/>
              </div>
              {isProviderAPos(user.provider) && <MarkupsCard/>}
              <TopProductsCard/>
          </Section>
      </>
    )
}

export { OfferPerformanceSection }
